import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaddaModule } from 'angular2-ladda';
import { TranslateModule } from "@ngx-translate/core";

import { ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { KpiComponent } from './kpi.component';
import { KpiRoutingModule } from './kpi-routing.module';
import { KpiService } from 'src/app/domains/kpi/services/kpi.service';

@NgModule({
  declarations: [
    KpiComponent
  ],
  imports: [
    KpiRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    TranslateModule.forChild(),
    LaddaModule.forRoot({
      spinnerColor: 'grey',
      style: 'zoom-in'
    })
  ],
  providers: [
    KpiService
  ]
})
export class KpiModule { }
